'use strict';

const $ = require('jquery');

/**
 * Add minheight to video with thumbnail element
 */
let videoThumbnailResize = function() {
    let videoContainers = document.querySelectorAll('.video_thumbnail');

    for (let i = 0; videoContainers.length > i; i++) {
        let videoContainer = videoContainers[i];
        let videoContainerImageContainer = videoContainer.querySelector('.video_thumbnail--image');
        let videoContainerImage = videoContainer.querySelector('.video_thumbnail--image img');
        let videoContainerContent = videoContainer.querySelector('.video_thumbnail--content');

        let minHeight = videoContainerContent.offsetHeight + 100 + 'px';

        videoContainer.style.minHeight = minHeight;
        videoContainerImageContainer.style.minHeight = minHeight;
        videoContainerImage.style.minHeight = minHeight;
    }
};

videoThumbnailResize();
$(window).resize(function() {
    videoThumbnailResize();
});
